//import Example from './example';

document.addEventListener("DOMContentLoaded", () => {
    // try {
    //     console.log("Modal imported successfully:", !!window.BootstrapModal);
    //     console.log(
    //         "Modal is callable:",
    //         typeof window.BootstrapModal === "function"
    //     );
    // } catch (error) {
    //     console.error("Import failed:", error);
    // }
    /**
     * Add error class to form when errors are present
     */
    /* Uncomment this section if you wnt popup form
    /*/
    const setErrorClasses = () => {
        const forms = document.querySelectorAll(".js-exit-intent-popup-tutor");
        forms.forEach(function (form) {
            const submitBtn = form.querySelector(".contact-submit");
            if (!submitBtn) return;
            const hasErrors = form.querySelector(".frm_error");
            if (hasErrors) {
                submitBtn.classList.add("contact-submit--with-errors");
            } else {
                submitBtn.classList.remove("contact-submit--with-errors");
            }
        });
    };
    setErrorClasses();

    /**
     * Modal show/hide with guarding to prevent re-opening shortly mid-dismissal
     */
    const modalElement = document.querySelector(".js-exit-intent-popup-tutor");
    if (!modalElement) return;

    const modal = new window.BootstrapModal(modalElement);

    let modalShown = false; // has the modal ever been shown
    let modalIsHiding = false; // is the modal currently hiding

    modalElement.addEventListener("hide.bs.modal", () => {
        modalIsHiding = true;
    });

    modalElement.addEventListener("hidden.bs.modal", () => {
        modalIsHiding = false;
        // If you want to allow retriggering, reset modalShown here:
        // modalShown = false;
    });

    // Exit-intent detection
    document.addEventListener("mouseout", (event) => {
        if (event.clientY <= 0 && !modalShown && !modalIsHiding) {
            modal.show();
            modalShown = true;
        }
    });
});
